import UpdateEventCheckoutRequestModelBase from '../_generated/modelBases/update-event-checkout-request-model-base';

export default class UpdateEventCheckoutRequestModel extends UpdateEventCheckoutRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
